module.exports = __webpack_public_path__ + "static/media/4.2.6-esg.97bcfa2d.png";